import React from 'react';
import './DeleteConfirmModal.css';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, customerName, type = 'customer', isLoading = false }) => {
  if (!isOpen) return null;

  const isProduct = type === 'product';
  const isBroadcast = type === 'broadcast';
  const isTemplate = type === 'template';
  const isLead = type === 'lead';
  const isAppointment = type === 'appointment';
  const isPromotion = type === 'promotion';
  const isMedia = type === 'media';
  let title, message;
  
  if (isMedia) {
    title = 'Delete Media';
    message = `Are you sure you want to delete <strong>${customerName}</strong>? This action cannot be undone and the file will be permanently removed.`;
  } else if (isProduct) {    title = 'Delete Product';
    message = `Are you sure you want to delete <strong>${customerName}</strong>? This action cannot be undone and the product will be removed from your catalog.`;
  } else if (isBroadcast) {
    title = 'Delete Broadcast';
    message = `Are you sure you want to delete <strong>${customerName}</strong>? This action cannot be undone and the broadcast will be permanently removed.`;
  } else if (isTemplate) {
    title = 'Delete Template';
    message = `Are you sure you want to delete <strong>${customerName}</strong>? This action cannot be undone and the template will be permanently removed.`;
  } else if (isLead) {
    title = 'Delete Lead';
    message = `Are you sure you want to delete <strong>${customerName}</strong>? This action cannot be undone and all lead information will be lost.`;
  } else if (isAppointment) {
    title = 'Delete Appointment';
    message = `Are you sure you want to delete <strong>${customerName}</strong>? This action cannot be undone and the appointment will be permanently removed.`;
  } else if (isPromotion) {
    title = 'Delete Promotion';
    message = `Are you sure you want to delete <strong>${customerName}</strong>? This action cannot be undone and the promotion campaign will be permanently removed.`;
  } else {
    title = 'Delete Customer';
    message = `Are you sure you want to delete <strong>${customerName}</strong>? This action cannot be undone and all conversation history will be lost.`;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="delete-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="delete-modal-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
        </div>
        <h2>{title}</h2>
        <p dangerouslySetInnerHTML={{ __html: message }} />
        <div className="delete-modal-actions">
          <button className="btn-cancel" onClick={onClose} disabled={isLoading}>
            Cancel
          </button>
          <button className="btn-delete" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;

